// Chinese Beginner Vocabulary - 50 unique items
// Each item supports 5 question types: target↔english, target↔pinyin, definition→target

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const chineseBeginnerItems: VocabularyItem[] = [
  // Greetings & Basic Phrases (1-10)
  {
    id: 'zh-beg-001',
    target: '你好',
    english: 'Hello',
    romanization: 'nǐ hǎo',
    definition: 'A common greeting used when meeting someone',
    partOfSpeech: 'interjection'
  },
  {
    id: 'zh-beg-002',
    target: '再见',
    english: 'Goodbye',
    romanization: 'zài jiàn',
    definition: 'A farewell expression when parting',
    partOfSpeech: 'interjection'
  },
  {
    id: 'zh-beg-003',
    target: '谢谢',
    english: 'Thank you',
    romanization: 'xiè xie',
    definition: 'An expression of gratitude',
    partOfSpeech: 'interjection'
  },
  {
    id: 'zh-beg-004',
    target: '对不起',
    english: 'Sorry',
    romanization: 'duì bu qǐ',
    definition: 'An apology expression',
    partOfSpeech: 'interjection'
  },
  {
    id: 'zh-beg-005',
    target: '请',
    english: 'Please',
    romanization: 'qǐng',
    definition: 'A polite word used when making requests',
    partOfSpeech: 'adverb'
  },
  {
    id: 'zh-beg-006',
    target: '是',
    english: 'Yes / Is',
    romanization: 'shì',
    definition: 'Affirmative response or the verb "to be"',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-beg-007',
    target: '不',
    english: 'No / Not',
    romanization: 'bù',
    definition: 'Negative word used to negate verbs',
    partOfSpeech: 'adverb'
  },
  {
    id: 'zh-beg-008',
    target: '好',
    english: 'Good',
    romanization: 'hǎo',
    definition: 'Describes something positive or satisfactory',
    partOfSpeech: 'adjective'
  },
  {
    id: 'zh-beg-009',
    target: '早上好',
    english: 'Good morning',
    romanization: 'zǎo shang hǎo',
    definition: 'A morning greeting',
    partOfSpeech: 'interjection'
  },
  {
    id: 'zh-beg-010',
    target: '晚安',
    english: 'Good night',
    romanization: 'wǎn ān',
    definition: 'A nighttime farewell or bedtime greeting',
    partOfSpeech: 'interjection'
  },

  // Pronouns & People (11-20)
  {
    id: 'zh-beg-011',
    target: '我',
    english: 'I / Me',
    romanization: 'wǒ',
    definition: 'First person singular pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'zh-beg-012',
    target: '你',
    english: 'You',
    romanization: 'nǐ',
    definition: 'Second person singular pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'zh-beg-013',
    target: '他',
    english: 'He / Him',
    romanization: 'tā',
    definition: 'Third person singular masculine pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'zh-beg-014',
    target: '她',
    english: 'She / Her',
    romanization: 'tā',
    definition: 'Third person singular feminine pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'zh-beg-015',
    target: '我们',
    english: 'We / Us',
    romanization: 'wǒ men',
    definition: 'First person plural pronoun',
    partOfSpeech: 'pronoun'
  },
  {
    id: 'zh-beg-016',
    target: '朋友',
    english: 'Friend',
    romanization: 'péng you',
    definition: 'A person you know well and like',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-017',
    target: '家人',
    english: 'Family',
    romanization: 'jiā rén',
    definition: 'Members of your household or relatives',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-018',
    target: '老师',
    english: 'Teacher',
    romanization: 'lǎo shī',
    definition: 'A person who teaches',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-019',
    target: '学生',
    english: 'Student',
    romanization: 'xué shēng',
    definition: 'A person who studies at school',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-020',
    target: '人',
    english: 'Person / People',
    romanization: 'rén',
    definition: 'A human being',
    partOfSpeech: 'noun'
  },

  // Numbers (21-30)
  {
    id: 'zh-beg-021',
    target: '一',
    english: 'One',
    romanization: 'yī',
    definition: 'The number 1',
    partOfSpeech: 'number'
  },
  {
    id: 'zh-beg-022',
    target: '二',
    english: 'Two',
    romanization: 'èr',
    definition: 'The number 2',
    partOfSpeech: 'number'
  },
  {
    id: 'zh-beg-023',
    target: '三',
    english: 'Three',
    romanization: 'sān',
    definition: 'The number 3',
    partOfSpeech: 'number'
  },
  {
    id: 'zh-beg-024',
    target: '四',
    english: 'Four',
    romanization: 'sì',
    definition: 'The number 4',
    partOfSpeech: 'number'
  },
  {
    id: 'zh-beg-025',
    target: '五',
    english: 'Five',
    romanization: 'wǔ',
    definition: 'The number 5',
    partOfSpeech: 'number'
  },
  {
    id: 'zh-beg-026',
    target: '六',
    english: 'Six',
    romanization: 'liù',
    definition: 'The number 6',
    partOfSpeech: 'number'
  },
  {
    id: 'zh-beg-027',
    target: '七',
    english: 'Seven',
    romanization: 'qī',
    definition: 'The number 7',
    partOfSpeech: 'number'
  },
  {
    id: 'zh-beg-028',
    target: '八',
    english: 'Eight',
    romanization: 'bā',
    definition: 'The number 8',
    partOfSpeech: 'number'
  },
  {
    id: 'zh-beg-029',
    target: '九',
    english: 'Nine',
    romanization: 'jiǔ',
    definition: 'The number 9',
    partOfSpeech: 'number'
  },
  {
    id: 'zh-beg-030',
    target: '十',
    english: 'Ten',
    romanization: 'shí',
    definition: 'The number 10',
    partOfSpeech: 'number'
  },

  // Common Nouns (31-40)
  {
    id: 'zh-beg-031',
    target: '水',
    english: 'Water',
    romanization: 'shuǐ',
    definition: 'Clear liquid essential for life',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-032',
    target: '饭',
    english: 'Rice / Meal',
    romanization: 'fàn',
    definition: 'Cooked rice or a meal in general',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-033',
    target: '茶',
    english: 'Tea',
    romanization: 'chá',
    definition: 'A hot beverage made from tea leaves',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-034',
    target: '书',
    english: 'Book',
    romanization: 'shū',
    definition: 'Written or printed pages bound together',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-035',
    target: '家',
    english: 'Home / House',
    romanization: 'jiā',
    definition: 'The place where one lives',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-036',
    target: '猫',
    english: 'Cat',
    romanization: 'māo',
    definition: 'A small furry pet animal that meows',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-037',
    target: '狗',
    english: 'Dog',
    romanization: 'gǒu',
    definition: 'A domesticated animal that barks',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-038',
    target: '车',
    english: 'Car / Vehicle',
    romanization: 'chē',
    definition: 'A wheeled vehicle for transportation',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-039',
    target: '手机',
    english: 'Mobile phone',
    romanization: 'shǒu jī',
    definition: 'A portable telephone device',
    partOfSpeech: 'noun'
  },
  {
    id: 'zh-beg-040',
    target: '钱',
    english: 'Money',
    romanization: 'qián',
    definition: 'Currency used to buy things',
    partOfSpeech: 'noun'
  },

  // Common Verbs & Actions (41-50)
  {
    id: 'zh-beg-041',
    target: '吃',
    english: 'To eat',
    romanization: 'chī',
    definition: 'To consume food through the mouth',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-beg-042',
    target: '喝',
    english: 'To drink',
    romanization: 'hē',
    definition: 'To consume liquids',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-beg-043',
    target: '看',
    english: 'To look / To watch',
    romanization: 'kàn',
    definition: 'To use eyes to observe something',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-beg-044',
    target: '听',
    english: 'To listen',
    romanization: 'tīng',
    definition: 'To use ears to perceive sound',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-beg-045',
    target: '说',
    english: 'To speak / To say',
    romanization: 'shuō',
    definition: 'To communicate using words',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-beg-046',
    target: '读',
    english: 'To read',
    romanization: 'dú',
    definition: 'To look at and understand written words',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-beg-047',
    target: '写',
    english: 'To write',
    romanization: 'xiě',
    definition: 'To form letters or characters on a surface',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-beg-048',
    target: '去',
    english: 'To go',
    romanization: 'qù',
    definition: 'To move from one place to another',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-beg-049',
    target: '来',
    english: 'To come',
    romanization: 'lái',
    definition: 'To move toward the speaker',
    partOfSpeech: 'verb'
  },
  {
    id: 'zh-beg-050',
    target: '爱',
    english: 'To love',
    romanization: 'ài',
    definition: 'To have strong affection for someone or something',
    partOfSpeech: 'verb'
  }
];
